import { Chip } from "@mui/material";
import { PromotionTypeValue } from "@quest_editor/constants";
import { getPromotionTypeOptions } from "@quest_editor/utils/view/constLabels";

const PromotionTypeChip = ({ type }: { type: PromotionTypeValue }) => {
  const promotionTypes = getPromotionTypeOptions();
  const label = promotionTypes.find((pt) => pt.value === type)?.label ?? type;

  return <Chip label={label} size="small" />;
};

export default PromotionTypeChip;
